import React from 'react';
import { getImageUrl, createFallbackImage } from '../../utils/imageUtils';
import './ProductEditItem.css';

const ProductEditItem = ({ product, onEdit }) => {

  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };
  
  // Função para truncar texto longo
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '-';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  return (
    <div className="product-edit-item">
      <div className="col-code" data-label="Código">
        {product.code}
      </div>
      
      <div className="col-name" data-label="Nome">
        <span title={product.name}>{product.name}</span>
      </div>

      <div className="col-tag" data-label="Marca">
        <span title={product.tag}>{product.tag || '-'}</span>
      </div>

      <div className="col-category" data-label="Categoria">
        <span title={product.category}>{product.category || '-'}</span>
      </div>
      
      <div className="col-price" data-label="Preço">
        {formatPrice(product.price)}
      </div>

      <div className="col-sale-price" data-label="Preço Promo">
        {product.salePrice ? formatPrice(product.salePrice) : '-'}
      </div>
      
      <div className="col-stock" data-label="Estoque">
        {product.stock}
      </div>

      <div className="col-description" data-label="Descrição">
        <span title={product.description}>
          {truncateText(product.description)}
        </span>
      </div>
      
      <div className="col-active" data-label="Ativo">
        <span className={`status ${product.active ? 'active' : 'inactive'}`}>
          {product.active ? 'Sim' : 'Não'}
        </span>
      </div>
      
      <div className="col-actions" data-label="Ações">
        <button 
          className="btn-edit" 
          onClick={onEdit}
        >
          Editar
        </button>
      </div>
    </div>
  );
};

export default ProductEditItem;
